import React from "react";
import OverviewLinkIcon from "./OverviewLinkIcon";

/**
 * Table cell: small "open overview" icon + monospace id (id in tooltip via title on span).
 * @param {keyof import('./overviewPaths').overviewPath} entity
 */
export default function OverviewIdCell({ entity, id, showIdText = true }) {
  if (id == null || id === "") return <span className="text-muted">—</span>;
  return (
    <span className="d-inline-flex align-items-center flex-wrap" style={{ gap: "0.35rem" }}>
      <OverviewLinkIcon entity={entity} id={id} />
      {showIdText ? (
        <span className="text-muted" style={{ fontFamily: "monospace", fontSize: "0.85em" }} title={String(id)}>
          {id}
        </span>
      ) : null}
    </span>
  );
}

/** Human-readable title with open-overview icon (e.g. country name in a city row). */
export function OverviewTitleWithLink({ entity, id, label }) {
  if (id == null || id === "") return <span>{label || "—"}</span>;
  return (
    <span className="d-inline-flex align-items-center flex-wrap" style={{ gap: "0.35rem" }}>
      <OverviewLinkIcon entity={entity} id={id} />
      <span>{label ?? String(id)}</span>
    </span>
  );
}
